export const CODE_MAX_LENGTH = 25
export const TITLE_MAX_LENGTH = 25
export const CODE_ALLOWED_REGEX = /[^A-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/g

export const sanitizeForCode = (value: string): string =>
  value
    .toUpperCase()
    .replace(CODE_ALLOWED_REGEX, '')
    .slice(0, CODE_MAX_LENGTH)
